import $ from 'jquery';

var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];
googletag.cmd.push(function() {
    googletag.pubads().disableInitialLoad();
});

var pbjs = pbjs || {};
pbjs.que = pbjs.que || [];
var PREBID_TIMEOUT = 700;

var adConfig = {};

function setAdConfig() {
    $.getJSON(window.adConfigUrl, function (data) {
        adConfig = data;
        setupAdDependencies();
    });
}

function setupAdDependencies() {
    if (adConfig.dfp) {
        $.getScript("https://www.googletagservices.com/tag/js/gpt.js");
        setupPrebidConfig();
        setupAdUnits();
    }

    if (adConfig.avantis) {
    }

    if (adConfig.adsense && !window.automatad) {
        if (window.innerWidth < 800) {
            $.getScript("//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js");
            (adsbygoogle = window.adsbygoogle || []).push({
                google_ad_client: "ca-pub-1600099712059267",
                enable_page_level_ads: true
            });
        }
    }
}

function setupAdUnits() {
    var loaded = false;
    var timerId = setInterval(function () {
        if (loaded) {
            clearInterval(timerId);
            return;
        }

        if (document.readyState !== 'complete') return;

        loaded = true;
        loadAdUnitsOnPage();
    }, 1000);
}

function loadAdUnitsOnPage() {
    $(".ad-unit").each(function() {
        new AdUnit($(this));
    });
    pbjs.que.push(function() {
        pbjs.requestBids({
            bidsBackHandler: initAdserver,
            timeout: PREBID_TIMEOUT
        });
    });
}

function initAdserver() {
    if (pbjs.initAdserverSet) return;
    pbjs.initAdserverSet = true;
    googletag.cmd.push(function() {
        pbjs.setTargetingForGPTAsync && pbjs.setTargetingForGPTAsync();
        adUnits.forEach(function (adUnit) {
            if (adUnit.trigger == null) adUnit.pubadsRefresh();

        });
    });
    adServerInitCallback();
}

var adUnits = [];

function getAdUnitById(id) {
    for (var i = 0; i < adUnits.length; i++) {
        var adUnit = adUnits[i];
        if (adUnit.id === id) return adUnit;
    }
    return null;
}

function AdUnit(div) {
    var adUnit = this;

    this.minWindowWidth = -1;
    if (div.is("[data-min-window-width]")) {
        this.minWindowWidth = div.attr("data-min-window-width");
        if (this.minWindowWidth > window.innerWidth) {
            div.hide();
            return;
        }
    }

    this.maxWindowWidth = -1;
    if (div.is("[data-max-window-width]")) {
        this.maxWindowWidth = div.attr("data-max-window-width");
        if (this.maxWindowWidth < window.innerWidth) {
            div.hide();
            return;
        }
    }

    if (div.is("[data-min-body-height]")) {
        if (div.attr("data-min-body-height") > $(document).height()) {
            div.hide();
            return;
        }
    }

    this.trigger = null;
    if (div.is("[data-trigger]")) {
        this.trigger = div.attr("data-trigger");
    }

    div.show();

    this.sticky = -1;
    this.stickyOffset;
    this.stickyOriginalPosition = div.css("position");
    if (div.is("[data-sticky]")) {
        this.sticky = div.attr("data-sticky");
        this.stickyOffset = div.offset().top;
    }

    this.isSticky = function() {
        return this.sticky > -1;
    };

    this.setId = function(id) {
        this.id = id;
        this.div.attr("id", this.id);
    };

    this.setSizes = function () {
        this.sizes = [];

        if ((this.minWindowWidth > -1) && this.minWindowWidth > window.innerWidth) return;

        var maxWidth = this.div.parent().width();
        this.config.sizes.forEach(function(s) {
            if (s[0] > maxWidth) return;
            adUnit.sizes.push(s);
        });
    };

    this.div = div;
    this.adUnitId = this.div.attr("data-ad-unit");
    this.config = adConfig.dfp.adUnits[this.adUnitId];
    this.sizes = [];
    this.dfpSlot = null;
    this.setSizes();

    this.viewabilityMet = false;
    this.refreshDue = false;
    this.forceRefresh = false;
    this.totalRefreshes = 0;

    if (this.config.forceRefresh) this.forceRefresh = this.config.forceRefresh;

    if (this.sizes.length == 0) {
        div.parent().hide();
        return;
    }

    this.setId("adunit-" + adUnits.length);

    //define dfp slot
    googletag.cmd.push(function() {
        adUnit.dfpSlot = googletag.defineSlot(adUnit.config.slotId, adUnit.sizes, adUnit.id);
        adUnit.dfpSlot.addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        googletag.display(adUnit.id);
    });

    this.getPrebidBidObject = function() {
        var json = {};
        Object.assign(json, adConfig.pbjsAdUnitBase || {bids: []});
        json.code = this.config.slotId;
        json.mediaTypes = {
            banner: {
                sizes: this.sizes
            }
        };
        json.bids = json.bids.concat(this.config.prebidConfig);
        //TODO: Replace quick-fix for IX and OFTMedia removal
        var newJsonBids = [];
        for (var i = 0; i < json.bids.length; i++) {
            var bidObj = json.bids[i];
            if (bidObj.bidder !== 'ix' && bidObj.bidder !== 'oftmedia') newJsonBids.push(bidObj);
        }
        json.bids = newJsonBids;

        return json;
    };

    //push prebid bidders if prebid
    if (this.config.prebidConfig) {
        pbjs.que.push(function() {
            pbjs.addAdUnits([adUnit.getPrebidBidObject()]);
        });
    }

    //function to refresh ad unit
    this.refreshAd = function () {
        adUnit.viewabilityMet = false;
        adUnit.refreshDue = false;

        adUnit.totalRefreshes++;
        if (adUnit.totalRefreshes > 25 && !this.forceRefresh) return;

        if (!adUnit.config.prebidConfig) {
            adUnit.pubadsRefresh();
            return;
        }

        pbjs.que.push(function () {
            pbjs.requestBids({
                timeout: PREBID_TIMEOUT,
                adUnitCodes: [adUnit.config.slotId],
                bidsBackHandler: function () {
                    pbjs.setTargetingForGPTAsync([adUnit.config.slotId]);
                    adUnit.pubadsRefresh();
                }
            });
        });
    };

    this.pubadsRefresh = function () {
        googletag.cmd.push(function () {
            googletag.pubads().refresh([adUnit.dfpSlot]);
        });
    };

    if (this.config.refresh) {
        setInterval(function() {
            if ((document.hidden || !adUnit.viewabilityMet) && (!adUnit.forceRefresh)) {
                adUnit.refreshDue = true;
                return;
            }
            adUnit.refreshAd();
        }, this.config.refresh);
    }

    adUnits.push(this);
}

function setupPrebidConfig() {
    pbjs.que.push(function () {
        var configObject = {};
        if (adConfig.pbjsConfig)
            configObject = adConfig.pbjsConfig;

        configObject.priceGranularity = {
            "buckets": [
                {
                    "min": 0,
                    "max": 1.50,
                    "increment": 0.01
                },
                {
                    "min": 1.50,
                    "max": 2.50,
                    "increment": 0.02
                },
                {
                    "min": 2.50,
                    "max": 10,
                    "increment": 0.05
                },
                {
                    "min": 10,
                    "max": 18,
                    "increment": 0.10
                },
                {
                    "min": 19,
                    "max": 37,
                    "increment": 1
                }
            ]
        };

        configObject.currency = {
            "adServerCurrency": "GBP",
            "granularityMultiplier": 1,
            "defaultRates": { "USD": { "GBP": 0.81 }}
        };

        configObject.consentManagement = {
            gdpr: {
                cmpApi: 'iab'
            }
        };

        configObject.useBidCache = true;
        configObject.disableAjaxTimeout = true;

        if (!configObject.userSync) configObject.userSync = {};
        configObject.userSync.userIds = [
            {
                name: "pubCommonId",
                storage: {
                    type: "cookie",
                    name: "_pubcid",
                    expires: 365
                }
            },
            {
                name: "criteo"
            }
        ];

        pbjs.setConfig(configObject);

        pbjs.bidderSettings = {
            districtm: {
                bidCpmAdjustment: function (bidCpm, bid) {
                    return bidCpm * 0.85;
                }
            }
        };
    });
}

function callTrigger(trigger) {
    adUnits.forEach(function (adUnit) {
        if (adUnit.trigger != null && adUnit.trigger == trigger) {
            adUnit.trigger = null;
            adUnit.pubadsRefresh();
        }
    });
}

function avantisCallBack(e) {
    callTrigger(e);
}

window.startLoadingAds = function() {
    if (typeof window.avantisEnabled == "undefined" || window.avantisEnabled) {
        // if (window.innerWidth > 1000) {
        //     $.getScript("//cdn.avantisvideo.com/avm/js/video-loader.js?id=7dfd55ec-50af-4813-90c9-4d5e57b6172c&tagId=2&subId=&callback=avantisUnitCallback");
        // } else {
        //     $.getScript("//cdn.avantisvideo.com/avm/js/video-loader.js?id=7dfd55ec-50af-4813-90c9-4d5e57b6172c&tagId=1&subId=&callback=avantisUnitCallback");
        // }
    }

    setAdConfig();

    googletag.cmd.push(function() {
        googletag.pubads().addEventListener('impressionViewable', function(e) {
            var adUnit = getAdUnitById(e.slot.getSlotElementId());
            if (adUnit) adUnit.viewabilityMet = true;
        });
    });

    $(window).focus(function() {
        adUnits.forEach(function (ad) {
            if (ad.refreshDue) ad.refreshAd();
        });
    });

//hide ads when they are too large for the page
    $(window).on('resize', function() {
        adUnits.forEach(function (adUnit) {
            adUnit.setSizes();
            if (adUnit.sizes.length == 0) adUnit.div.hide();
        });
    });

//handle sticky ads
    $(document).scroll(function() {
        var scrollTop = $(window).scrollTop();
        adUnits.forEach(function(adUnit) {
            if (!adUnit.isSticky() || adUnit.sizes == 0) return;
            if ((parseInt(adUnit.stickyOffset) - parseInt(adUnit.sticky)) < scrollTop) {
                if (adUnit.div.css("position") !== adUnit.stickyOriginalPosition) return;
                adUnit.div.css("position", "fixed");
                adUnit.div.css("top", adUnit.sticky + "px");
            }
            else if (adUnit.div.css("position") !== adUnit.stickyOriginalPosition) {
                adUnit.div.css("position", adUnit.stickyOriginalPosition, "top", "");
            }
        });
    });
};